import React from "react";
import ImageSlider from "./ImageSlider";

const Test = () => {
  const categoryData = [
    // First Row
    {
      id: 1,
      title: "Visakhapatnam",
      icon: "fa fa-city",
      students: 15420,
      colleges: 45,
      link: "/destinations/visakhapatnam",
    },
    {
      id: 2,
      title: "Vijayawada",
      icon: "fa fa-building",
      students: 12890,
      colleges: 38,
      link: "/destinations/vijayawada",
    },
    {
      id: 3,
      title: "Tirupati",
      icon: "fa fa-university",
      students: 11230,
      colleges: 32,
      link: "/destinations/tirupati",
    },
    {
      id: 4,
      title: "Guntur",
      icon: "fa fa-graduation-cap",
      students: 9870,
      colleges: 28,
      link: "/destinations/guntur",
    },
    // Second Row
    {
      id: 5,
      title: "Kakinada",
      icon: "fa fa-water",
      students: 7650,
      colleges: 22,
      link: "/destinations/kakinada",
    },
    {
      id: 6,
      title: "Nellore",
      icon: "fa fa-sun",
      students: 6540,
      colleges: 19,
      link: "/destinations/nellore",
    },
    {
      id: 7,
      title: "Anantapur",
      icon: "fa fa-mountain",
      students: 5430,
      colleges: 16,
      link: "/destinations/anantapur",
    },
    {
      id: 8,
      title: "Kurnool",
      icon: "fa fa-landmark",
      students: 4320,
      colleges: 14,
      link: "/destinations/kurnool",
    },
  ];

  // Split into rows of 4
  const firstRow = categoryData.slice(0, 4);
  const secondRow = categoryData.slice(4, 8);

  const universities = [
    {
      name: "Andhra University (AU)",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkivu4pf_958YVoV4C1db4na9Vx3sng6aUTQ&s",
      category: "Central University",
      students: "12,500",
      established: "1926",
      accreditation: "NAAC 'A++'",
      location: "Visakhapatnam",
      universityType: "Public University",
      ranking: "NIRF Rank: 37",
      iconType: "fa-university",
      iconColor: "#0056a3",
    },
    {
      name: "Sri Venkateswara University (SVU)",
      image:
        "https://content.jdmagicbox.com/v2/comp/tirupati/q4/9999px877.x877.221116223648.u4q4/catalogue/sv-university-prakasam-nagar-colony-tirupati-universities-pozcx8ptji.jpg",
      category: "State University",
      students: "15,200",
      established: "1954",
      accreditation: "NAAC 'A+'",
      location: "Tirupati",
      universityType: "Public University",
      ranking: "NIRF Rank: 68",
      iconType: "fa-university",
      iconColor: "#004d40",
    },
    {
      name: "Acharya Nagarjuna University (ANU)",
      image:
        "https://lawsection.in/wp-content/uploads/2026/01/cover_3531.png.webp",
      category: "State University",
      students: "8,900",
      established: "1976",
      accreditation: "NAAC 'A'",
      location: "Guntur",
      universityType: "Public University",
      ranking: "NIRF Rank: 89",
      iconType: "fa-university",
      iconColor: "#b3470c",
    },
    {
      name: "GITAM (Deemed to be University)",
      image:
        "https://www.collegeyaar.in/wp-content/uploads/2026/02/image-1-1024x768.jpeg",
      category: "Deemed University",
      students: "10,100",
      established: "1980",
      accreditation: "NAAC 'A+'",
      location: "Visakhapatnam",
      universityType: "Private Deemed",
      ranking: "NIRF Rank: 87 (Engg.)",
      iconType: "fa-graduation-cap",
      iconColor: "#2e7d32",
    },
    {
      name: "VIT-AP University, Amaravati",
      image:
        "https://ik.imagekit.io/ak2ol9uti/college-profiles/VIT-AP%20University.png",
      category: "Private University",
      students: "5,600",
      established: "2017",
      accreditation: "UGC Recognized",
      location: "Amaravati",
      universityType: "Private University",
      ranking: "Ranked #1 in AP",
      iconType: "fa-graduation-cap",
      iconColor: "#f9a825",
    },
    {
      name: "SRM University, AP - Amaravati",
      image:
        "https://www.deccanchronicle.com/h-upload/2024/08/03/1828565-9.webp",
      category: "Private University",
      students: "4,200",
      established: "2017",
      accreditation: "QS 5-Star Rated",
      location: "Amaravati",
      universityType: "Private University",
      ranking: "Top Emerging University",
      iconType: "fa-graduation-cap",
      iconColor: "#bf360c",
    },
  ];

  return (
    <div>
      <>
        <link
          rel="stylesheet"
          id="wc-blocks-style-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/woocommerce/assets/client/blocks/wc-blocks.css?ver=wc-9.8.7"
          media="all"
        />
        <link
          rel="stylesheet"
          id="contact-form-7-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/contact-form-7/includes/css/styles.css?ver=6.0.6"
          media="all"
        />
        <link
          rel="stylesheet"
          id="woocommerce-layout-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/woocommerce/assets/css/woocommerce-layout.css?ver=9.8.7"
          media="all"
        />
        <link
          rel="stylesheet"
          id="woocommerce-smallscreen-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/woocommerce/assets/css/woocommerce-smallscreen.css?ver=9.8.7"
          media="only screen and (max-width: 768px)"
        />
        <link
          rel="stylesheet"
          id="woocommerce-general-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/woocommerce/assets/css/woocommerce.css?ver=9.8.7"
          media="all"
        />
        <link
          rel="stylesheet"
          id="brands-styles-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/woocommerce/assets/css/brands.css?ver=9.8.7"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-icons-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/elementor/assets/lib/eicons/css/elementor-icons.min.css?ver=5.36.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-frontend-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/elementor/assets/css/frontend.min.css?ver=3.28.4"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-post-8-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/css/post-8.css?ver=1653540729"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-post-42-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/css/post-42.css?ver=1653617112"
          media="all"
        />
        <link
          rel="stylesheet"
          id="skillup-woocommerce-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/woocommerce.css?ver=1.0.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="learnpress-widgets-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/learnpress/assets/css/widgets.min.css?ver=4.2.8.4"
          media="all"
        />
        <link
          rel="stylesheet"
          id="skillup-theme-fonts-css"
          href="https://fonts.googleapis.com/css?family=Muli:300,400,600,700|Jost:400,500,600,700&subset=latin%2Clatin-ext%2Clatin%2Clatin-ext"
          media="all"
        />
        <link
          rel="stylesheet"
          id="all-awesome-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/all-awesome.css?ver=5.11.2"
          media="all"
        />
        <link
          rel="stylesheet"
          id="flaticon-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/flaticon.css?ver=1.0.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="themify-icons-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/themify-icons.css?ver=1.0.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="animate-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/animate.css?ver=3.6.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="bootstrap-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/bootstrap.css?ver=5.0.2"
          media="all"
        />
        <link
          rel="stylesheet"
          id="slick-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/slick.css?ver=1.8.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="magnific-popup-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/magnific-popup.css?ver=1.1.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="perfect-scrollbar-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/perfect-scrollbar.css?ver=0.6.12"
          media="all"
        />
        <link
          rel="stylesheet"
          id="sliding-menu-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/sliding-menu.min.css?ver=0.3.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="skillup-template-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/css/template.css?ver=1.0"
          media="all"
        />
        <style
          id="skillup-template-inline-css"
          dangerouslySetInnerHTML={{
            __html:
              "\n:root {--skillup-theme-color: #03b97c;--skillup-second-color: #F5C34B;--skillup-text-color: #3c4852;--skillup-link-color: #333d46;--skillup-link_hover_color: #03b97c;--skillup-heading-color: #333d46;--skillup-theme-hover-color: #02875a;--skillup-second-hover-color: #0A2357;--skillup-main-font: 'Muli';--skillup-main-font-size: 15px;--skillup-main-font-weight: 300,400,600,700;--skillup-heading-font: 'Jost';--skillup-heading-font-weight: 600;--skillup-theme-color-005: rgba(3, 185, 124, 0.05);\t\t\t  --skillup-theme-color-007: rgba(3, 185, 124, 0.07);\t\t\t  --skillup-theme-color-010: rgba(3, 185, 124, 0.1);\t\t\t  --skillup-theme-color-015: rgba(3, 185, 124, 0.15);\t\t\t  --skillup-theme-color-020: rgba(3, 185, 124, 0.2);\t\t\t  --skillup-theme-color-050: rgba(3, 185, 124, 0.5);\t\t\t  --skillup-second-color-050: rgba(245, 195, 75, 0.5);\t\t\t}\n/*# sourceURL=skillup-template-inline-css */\n",
          }}
        />
        <link
          rel="stylesheet"
          id="skillup-style-css"
          href="https://demoapus1.com/skillup/wp-content/themes/skillup/style.css?ver=1.0"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-gf-local-roboto-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/google-fonts/css/roboto.css?ver=1746754665"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-gf-local-robotoslab-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/google-fonts/css/robotoslab.css?ver=1746754667"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-gf-local-jost-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/google-fonts/css/jost.css?ver=1746754660"
          media="all"
        />
        <link
          rel="https://api.w.org/"
          href="https://demoapus1.com/skillup/wp-json/"
        />
        <link
          rel="alternate"
          title="JSON"
          type="application/json"
          href="https://demoapus1.com/skillup/wp-json/wp/v2/pages/42"
        />
        <link
          rel="EditURI"
          type="application/rsd+xml"
          title="RSD"
          href="https://demoapus1.com/skillup/xmlrpc.php?rsd"
        />
        {/*  */}
        <link
          rel="stylesheet"
          id="elementor-post-173-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/css/post-173.css?ver=1653540729"
          media="all"
        />
        <link
          rel="stylesheet"
          id="widget-heading-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/elementor/assets/css/widget-heading.min.css?ver=3.28.4"
          media="all"
        />
        <link
          rel="stylesheet"
          id="widget-spacer-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/elementor/assets/css/widget-spacer.min.css?ver=3.28.4"
          media="all"
        />
        <link
          rel="stylesheet"
          id="widget-image-css"
          href="https://demoapus1.com/skillup/wp-content/plugins/elementor/assets/css/widget-image.min.css?ver=3.28.4"
          media="all"
        />
        <link
          rel="stylesheet"
          id="elementor-post-120-css"
          href="https://demoapus1.com/skillup/wp-content/uploads/elementor/css/post-120.css?ver=1653540729"
          media="all"
        />
        <div id="wrapper-container" className="wrapper-container">
          <div
            id="apus-mobile-menu"
            className="apus-offcanvas d-block d-lg-none"
          >
            <div className="apus-offcanvas-body flex-column d-flex">
              <div className="header-offcanvas">
                <div className="container">
                  <div className="d-flex align-items-center">
                    <div className="logo logo-theme">
                      <a href="testskillup/">
                        <img
                          src="https://demoapus1.com/skillup/wp-content/themes/skillup/images/logo.png"
                          alt="Skillup"
                        />
                      </a>
                    </div>
                    <div className="ms-auto">
                      <a className="btn-toggle-canvas" data-toggle="offcanvas">
                        <i className="ti-close" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="offcanvas-content">
                <div className="middle-offcanvas">
                  <nav
                    id="menu-main-menu-navbar"
                    className="navbar navbar-offcanvas"
                    role="navigation"
                  >
                    <div
                      id="mobile-menu-container"
                      className="menu-primary-mobile-menu-container"
                    >
                      <ul id="menu-primary-mobile-menu" className="">
                        <li
                          id="menu-item-1437"
                          className="has-submenu active menu-item-1437"
                        >
                          <a href="#">Home</a>
                          <ul className="sub-menu">
                            <li
                              id="menu-item-1438"
                              className="active menu-item-1438"
                            >
                              <a href="skillup/">Home 1</a>
                            </li>
                            <li id="menu-item-1439" className="menu-item-1439">
                              <a href="skillup/home-2/">Home 2</a>
                            </li>
                            <li id="menu-item-1440" className="menu-item-1440">
                              <a href="skillup/home-3/">Home 3</a>
                            </li>
                            <li id="menu-item-1441" className="menu-item-1441">
                              <a href="skillup/home-4/">Home 4</a>
                            </li>
                            <li id="menu-item-1442" className="menu-item-1442">
                              <a href="skillup/home-5/">Home 5</a>
                            </li>
                            <li id="menu-item-1443" className="menu-item-1443">
                              <a href="skillup/home-6/">Home 6</a>
                            </li>
                          </ul>
                        </li>
                        <li
                          id="menu-item-1444"
                          className="has-submenu menu-item-1444"
                        >
                          <a href="#">Courses</a>
                          <ul className="sub-menu">
                            <li
                              id="menu-item-1445"
                              className="has-submenu menu-item-1445"
                            >
                              <a href="#">Courses – Grid</a>
                              <ul className="sub-menu">
                                <li
                                  id="menu-item-1446"
                                  className="menu-item-1446"
                                >
                                  <a href="course=style1">Style 1</a>
                                </li>
                                <li
                                  id="menu-item-1447"
                                  className="menu-item-1447"
                                >
                                  <a href="course=style2">Style 2</a>
                                </li>
                                <li
                                  id="menu-item-1448"
                                  className="menu-item-1448"
                                >
                                  <a href="course=style3">Style 3</a>
                                </li>
                                <li
                                  id="menu-item-1449"
                                  className="menu-item-1449"
                                >
                                  <a href="course=style4">Style 4</a>
                                </li>
                              </ul>
                            </li>
                            <li id="menu-item-1450" className="menu-item-1450">
                              <a href="course=list">Courses – List</a>
                            </li>
                          </ul>
                        </li>
                        <li id="menu-item-1454" className="menu-item-1454">
                          <a href="skillup/blog/">Blog</a>
                        </li>
                        <li id="menu-item-1451" className="menu-item-1451">
                          <a href="skillup/shop/">Shop</a>
                        </li>
                        <li id="menu-item-1452" className="menu-item-1452">
                          <a href="skillup/contact-us/">Contact Us</a>
                        </li>
                        <li id="menu-item-1453" className="menu-item-1453">
                          <a href="skillup/about-us/">About Us</a>
                        </li>
                      </ul>
                    </div>{" "}
                  </nav>
                </div>
              </div>
              <div className="mt-auto top-wrapper-menu">
                <a
                  className="btn-login btn btn-theme btn-inverse d-block"
                  href="skillup/lp-profile/"
                >
                  <i className="fas fa-sign-in-alt pre" />
                  Login/Register{" "}
                </a>
              </div>
            </div>
          </div>
          <div className="over-dark" />{" "}
          <div
            id="apus-header-mobile"
            className="header-mobile d-block d-lg-none clearfix"
          >
            <div className="container">
              <div className="row d-flex align-items-center">
                <div className="col-5">
                  <div className="logo logo-theme">
                    <a href="skillup/">
                      <img
                        src="https://demoapus1.com/skillup/wp-content/themes/skillup/images/logo.png"
                        alt="Skillup"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-7 d-flex align-items-center justify-content-end">
                  <div className="top-wrapper-menu">
                    <a
                      className="drop-dow btn-menu-account"
                      href="skillup/lp-profile/"
                    >
                      <i className="ti-user" />
                    </a>
                  </div>
                  <a href="#navbar-offcanvas" className="btn-showmenu">
                    <i className="mobile-menu-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <section
            style={{
            //   height: "55px",
              background: "linear-gradient(90deg, #ffffff, #f5fff9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 30px",
              position: "sticky",
              top: 0,
              zIndex: 999,
              whiteSpace: "nowrap",


            }}
          >
            {/* LEFT SECTION */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "40px",
                flexShrink: 0,
              }}
            >
              {/* LOGO */}
              <div
                className="d-flex align-items-center gap-3"
                style={{
                  paddingRight: "20px",
                  borderRight: "1px solid #dfeee5",
                }}
              >
                <img
                  src="https://forests.ap.gov.in/uploads/images/aplogo.png"
                  alt="logo"
                  style={{
                    width: "70px",
                    height: "7-px",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                />

                <div>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: "700",
                      color: "#03b97c",
                      lineHeight: "22px",
                    }}
                  >
                    Student Transfers
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      marginTop: "3px",
                      letterSpacing: "1px",
                    }}
                  >
                    Academic Year 2026-27
                  </div>
                </div>
              </div>

              {/* MENU */}
              <nav>
                <ul
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "28px",
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {["Home", "Courses", "Blog", "Shop", "Pages"].map(
                    (item, index) => (
                      <li key={index}>
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#2d3748",
                            fontWeight: "600",
                            fontSize: "15px",
                            transition: "0.3s",
                            position: "relative",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = "#03b97c";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = "#2d3748";
                          }}
                        >
                          {item}
                        </a>
                      </li>
                    ),
                  )}
                </ul>
              </nav>
            </div>

            {/* RIGHT SECTION */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexShrink: 0,
              }}
            >
              <button
                className="btn"
                style={{
                  background: "#03b97c",
                  color: "#fff",
                  borderRadius: "30px",
                  padding: "8px 18px",
                  fontWeight: "600",
                  border: "none",
                  boxShadow: "0 3px 8px rgba(3,185,124,0.25)",
                }}
              >
                Student Login
              </button>

              <button
                className="btn"
                style={{
                  background: "#fff",
                  color: "#03b97c",
                  border: "1px solid #03b97c",
                  borderRadius: "30px",
                  padding: "8px 18px",
                  fontWeight: "600",
                }}
              >
                College Login
              </button>

              <button
                className="btn"
                style={{
                  background: "#1f2937",
                  color: "#fff",
                  borderRadius: "30px",
                  padding: "8px 18px",
                  fontWeight: "600",
                  border: "none",
                }}
              >
                Department Login
              </button>
            </div>
          </section>
          <div id="apus-main-content" style={{ paddingTop: 0 }}>
            <section id="main-container" className="container inner">
              <div className="row">
                <div id="main-content" className="main-page col-12">
                  <div id="main" className="site-main clearfix" role="main">
                    <div
                      data-elementor-type="wp-page"
                      data-elementor-id={42}
                      className="elementor elementor-42"
                    >
                      <ImageSlider />
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-b92f6b4 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="b92f6b4"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2b9d1ba"
                            data-id="2b9d1ba"
                            data-element_type="column"
                            data-settings='{"background_background":"classic"}'
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-b90cd01 elementor-widget elementor-widget-apus_element_brands"
                                data-id="b90cd01"
                                data-element_type="widget"
                                data-widget_type="apus_element_brands.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="widget-brand flex-wrap d-xl-flex align-items-center  carousel ">
                                    <div className="top-info">
                                      <h2 className="title">
                                        {" "}
                                        Over 700+ Cources In One Place
                                      </h2>
                                    </div>
                                    <div className="content-inner">
                                      <div
                                        className="slick-carousel slick-initialized slick-slider"
                                        data-items={4}
                                        data-large={4}
                                        data-medium={3}
                                        data-small={3}
                                        data-smallest={2}
                                        data-pagination="false"
                                        data-nav="true"
                                      >
                                        <div className="slick-list draggable">
                                          <div
                                            className="slick-track"
                                            style={{
                                              opacity: 1,
                                              width: 940,
                                              transform:
                                                "translate3d(0px, 0px, 0px)",
                                            }}
                                          >
                                            <div
                                              className="item slick-slide slick-current slick-active"
                                              data-slick-index={0}
                                              aria-hidden="false"
                                              style={{ width: 235 }}
                                              tabIndex={0}
                                            >
                                              <div className="brand-item d-flex align-items-center justify-content-center">
                                                <a href="#" tabIndex={0}>
                                                  <img
                                                    decoding="async"
                                                    src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/lg-1.png"
                                                    alt="Image"
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                            <div
                                              className="item slick-slide slick-active"
                                              data-slick-index={1}
                                              aria-hidden="false"
                                              style={{ width: 235 }}
                                              tabIndex={0}
                                            >
                                              <div className="brand-item d-flex align-items-center justify-content-center">
                                                <a href="#" tabIndex={0}>
                                                  <img
                                                    decoding="async"
                                                    src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/lg-5.png"
                                                    alt="Image"
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                            <div
                                              className="item slick-slide slick-active"
                                              data-slick-index={2}
                                              aria-hidden="false"
                                              style={{ width: 235 }}
                                              tabIndex={0}
                                            >
                                              <div className="brand-item d-flex align-items-center justify-content-center">
                                                <a href="#" tabIndex={0}>
                                                  <img
                                                    decoding="async"
                                                    src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/lg-6.png"
                                                    alt="Image"
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                            <div
                                              className="item slick-slide slick-active"
                                              data-slick-index={3}
                                              aria-hidden="false"
                                              style={{ width: 235 }}
                                              tabIndex={0}
                                            >
                                              <div className="brand-item d-flex align-items-center justify-content-center">
                                                <a href="#" tabIndex={0}>
                                                  <img
                                                    decoding="async"
                                                    src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/lg-7.png"
                                                    alt="Image"
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-b6ba09d elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="b6ba09d"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-30e4835"
                            data-id="30e4835"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-4f8e989 elementor-widget elementor-widget-heading"
                                data-id="4f8e989"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    explore Featured{" "}
                                    <span className="text-theme">Courses</span>
                                  </h2>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-f63e494 elementor-widget__width-initial elementor-widget elementor-widget-text-editor"
                                data-id="f63e494"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  Lorem ipsum dolor sit amet, consectetur
                                  adipiscing elit, sed do eiusmod tempor
                                  incididunt ut labore et dolore magna aliqua.
                                  Ut enim ad minim veniam.{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-0f9cf25 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="0f9cf25"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: "100%", left: "0" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-81fecd5"
                            data-id="81fecd5"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-aa41e32 elementor-widget elementor-widget-skillup_learnpress_courses"
                                data-id="aa41e32"
                                data-element_type="widget"
                                data-settings='{"columns_tablet":"2","columns":3}'
                                data-widget_type="skillup_learnpress_courses.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="widget m-0 widget-courses">
                                    <div className="row">
                                      {/* Map through universities data */}
                                      {universities.map((university, index) => (
                                        <div
                                          key={index}
                                          className="col-xl-4 col-md-6 col-12 d-flex"
                                        >
                                          <div className="course-grid w-100 m-0 post-1084 lp_course type-lp_course status-publish has-post-thumbnail hentry h-100">
                                            <div className="course-layout-item h-100">
                                              <div className="course-entry h-100 d-flex flex-column">
                                                {/* college thumbnail */}
                                                <div className="course-cover">
                                                  <div className="course-cover-thumb">
                                                    <figure className="entry-thumb">
                                                      <a
                                                        className="post-thumbnail"
                                                        href="#"
                                                        aria-hidden="true"
                                                      >
                                                        <div className="image-wrapper">
                                                          <img
                                                            fetchpriority={
                                                              index === 0
                                                                ? "high"
                                                                : "lazy"
                                                            }
                                                            decoding="async"
                                                            width={525}
                                                            height={345}
                                                            src={
                                                              university.image
                                                            }
                                                            className="attachment-skillup-course-grid size-skillup-course-grid"
                                                            alt={
                                                              university.name
                                                            }
                                                            style={{
                                                              objectFit:
                                                                "contain",
                                                              background:
                                                                "#f0f2f5",
                                                              padding: "10px",
                                                              width: "100%",
                                                              height: "200px",
                                                            }}
                                                          />
                                                        </div>
                                                      </a>
                                                    </figure>
                                                  </div>
                                                </div>

                                                <div className="course-layout-content d-flex flex-column flex-grow-1">
                                                  <div className="course-info-top d-flex">
                                                    {/* Category */}
                                                    <div className="course-category">
                                                      <a
                                                        className="course-category-item"
                                                        href="#"
                                                      >
                                                        {university.category}
                                                      </a>
                                                    </div>
                                                    {/* number students */}
                                                    <div className="course-student-number ms-auto">
                                                      {university.students}+
                                                      Students
                                                    </div>
                                                  </div>

                                                  {/* college title */}
                                                  <h3 className="course-title">
                                                    <a href="#">
                                                      {university.name}
                                                    </a>
                                                  </h3>

                                                  <div className="course-meta-middle">
                                                    {/* established */}
                                                    <div className="course-duration course-meta-field">
                                                      <i className="fa fa-calendar text-danger" />
                                                      Est.{" "}
                                                      {university.established}
                                                    </div>
                                                    {/* accreditation */}
                                                    <div className="course-lesson-number course-meta-field">
                                                      <i className="fa fa-trophy text-success" />
                                                      {university.accreditation}
                                                    </div>
                                                    <div className="course-level course-meta-field">
                                                      <i className="fa fa-map-marker text-warning" />
                                                      {university.location}
                                                    </div>
                                                  </div>

                                                  <div className="course-meta-bottom d-flex align-items-center mt-auto">
                                                    {/* college type */}
                                                    <div className="lp-course-author d-flex align-items-center">
                                                      <div className="course-author__pull-left d-flex align-items-center justify-content-center">
                                                        <i
                                                          className={`fa ${university.iconType}`}
                                                          style={{
                                                            fontSize: "24px",
                                                            color:
                                                              university.iconColor,
                                                          }}
                                                        ></i>
                                                      </div>
                                                      <div className="author-title">
                                                        <a href="#">
                                                          <span className="instructor-display-name">
                                                            {
                                                              university.universityType
                                                            }
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                    {/* ranking */}
                                                    <div className="course-meta-field course-meta-price ms-auto">
                                                      <div className="course-price">
                                                        <span className="course-item-price">
                                                          <span
                                                            className="price"
                                                            style={{
                                                              color: "#ff8c00",
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            {university.ranking}
                                                          </span>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Explore More Button */}
                              <div
                                className="elementor-element elementor-element-2148e33 elementor-align-center elementor-widget elementor-widget-button"
                                data-id="2148e33"
                                data-element_type="widget"
                                data-widget_type="button.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-button-wrapper">
                                    <a
                                      className="elementor-button elementor-button-link elementor-size-md"
                                      href="#"
                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-text">
                                          Explore More Colleges & Universities
                                          in AP
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-be0ba1d elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="be0ba1d"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          {firstRow.map((item) => (
                            <div
                              key={item.id}
                              className="elementor-column elementor-col-25 elementor-top-column elementor-element"
                              data-id={item.id}
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-widget elementor-widget-skillup_category_banner"
                                  data-id={item.id}
                                  data-element_type="widget"
                                  data-widget_type="skillup_category_banner.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="widget-category-banner">
                                      <a href={item.link}>
                                        <div className="inner">
                                          <div className="banner-content-wrapper d-flex flex-column style1">
                                            <div className="features-box-image d-flex align-items-center justify-content-center icon">
                                              <i className={item.icon} />
                                            </div>
                                            <div className="right-inner">
                                              <h3 className="banner-title">
                                                {item.title}
                                              </h3>
                                              <div className="number">
                                                <span>
                                                  {item.students.toLocaleString()}
                                                </span>{" "}
                                                Students Migrated
                                              </div>
                                              <div
                                                className="colleges"
                                                style={{
                                                  fontSize: 13,
                                                  color: "#888",
                                                  marginTop: 5,
                                                }}
                                              >
                                                <i
                                                  className="fa fa-building"
                                                  style={{ marginRight: 5 }}
                                                />
                                                {item.colleges} Educational
                                                Institutions
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-8b11f4a elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="8b11f4a"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          {secondRow.map((item) => (
                            <div
                              key={item.id}
                              className="elementor-column elementor-col-25 elementor-top-column elementor-element"
                              data-id={item.id}
                              data-element_type="column mt-1"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-widget elementor-widget-skillup_category_banner"
                                  data-id={item.id}
                                  data-element_type="widget"
                                  data-widget_type="skillup_category_banner.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="widget-category-banner">
                                      <a href={item.link}>
                                        <div className="inner">
                                          <div className="banner-content-wrapper d-flex flex-column style1">
                                            <div className="features-box-image d-flex align-items-center justify-content-center icon">
                                              <i className={item.icon} />
                                            </div>
                                            <div className="right-inner">
                                              <h3 className="banner-title">
                                                {item.title}
                                              </h3>
                                              <div className="number">
                                                <span>
                                                  {item.students.toLocaleString()}
                                                </span>{" "}
                                                Students Migrated
                                              </div>
                                              <div
                                                className="colleges"
                                                style={{
                                                  fontSize: 13,
                                                  color: "#888",
                                                  marginTop: 5,
                                                }}
                                              >
                                                <i
                                                  className="fa fa-building"
                                                  style={{ marginRight: 5 }}
                                                />
                                                {item.colleges} Educational
                                                Institutions
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-f382ab6 elementor-section-stretched elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="f382ab6"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-8e58d77"
                            data-id="8e58d77"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-3f9bb51 elementor-widget elementor-widget-heading"
                                data-id="3f9bb51"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    Top Educational Destinations for AP Students
                                  </h2>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-9be77f7 elementor-widget elementor-widget-text-editor"
                                data-id="9be77f7"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  Every year, thousands of students from Andhra
                                  Pradesh migrate to major educational hubs
                                  within the state for quality higher education.
                                  Visakhapatnam, Vijayawada, and Tirupati emerge
                                  as the top choices offering excellent academic
                                  infrastructure, placement opportunities, and
                                  vibrant campus life.
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-8e9ac10 elementor-widget elementor-widget-text-editor"
                                data-id="8e9ac10"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  <ul className="list-check">
                                    <li>
                                      <i className="fas fa-check" />
                                      50,000+ students migrated annually within
                                      AP
                                    </li>
                                    <li>
                                      <i className="fas fa-check" />
                                      200+ top colleges across 13 districts
                                    </li>
                                    <li>
                                      <i className="fas fa-check" />
                                      Scholarship programs for AP residents
                                    </li>
                                    <li>
                                      <i className="fas fa-check" />
                                      Free career counseling & guidance
                                    </li>
                                  </ul>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-463a2e9 elementor-widget elementor-widget-button"
                                data-id="463a2e9"
                                data-element_type="widget"
                                data-widget_type="button.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-button-wrapper">
                                    <a
                                      className="elementor-button elementor-button-link elementor-size-md"
                                      href="/student-migration-guide"
                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-text">
                                          Explore Migration Options
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b993c1f"
                            data-id="b993c1f"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-7d97344 elementor-widget elementor-widget-image"
                                data-id="7d97344"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={470}
                                    height={400}
                                    src="https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463884723_lmp-2.png"
                                    className="attachment-full size-full wp-image-222"
                                    alt="AP Student Migration"
                                    srcSet="https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463884723_lmp-2.png, https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463884723_lmp-2.png"
                                    sizes="(max-width: 470px) 100vw, 470px"
                                  />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-0691626 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="0691626"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b63bc51"
                            data-id="b63bc51"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-a83dc5e elementor-widget elementor-widget-image"
                                data-id="a83dc5e"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width={600}
                                    height={510}
                                    src="https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463968456_lmp-1.png"
                                    className="attachment-full size-full wp-image-229"
                                    alt=""
                                    srcSet="https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463968456_lmp-1.png 600w, https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463968456_lmp-1-300x255.png 300w, https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/APFD/UPLOADS/1779463968456_lmp-1-500x425.png 500w"
                                    sizes="(max-width: 600px) 100vw, 600px"
                                  />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-bc2d116"
                            data-id="bc2d116"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-98944ec elementor-widget elementor-widget-apus_element_address_box"
                                data-id="98944ec"
                                data-element_type="widget"
                                data-widget_type="apus_element_address_box.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="widget-box style2">
                                    <div className="row">
                                      <div className="item col-12 col-sm-12">
                                        <div className="item-box style2">
                                          <div className="top-inner">
                                            <div className="features-box-image number">
                                              1
                                            </div>
                                          </div>
                                          <div className="features-box-content">
                                            <h3 className="title">
                                              Research & Shortlist
                                            </h3>
                                            <div className="description">
                                              Explore top colleges in
                                              Visakhapatnam, Vijayawada,
                                              Tirupati and compare courses,
                                              fees, and placement records.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="item col-12 col-sm-12">
                                        <div className="item-box style2">
                                          <div className="top-inner">
                                            <div className="features-box-image number">
                                              2
                                            </div>
                                          </div>
                                          <div className="features-box-content">
                                            <h3 className="title">
                                              Apply for Admission
                                            </h3>
                                            <div className="description">
                                              Submit applications online, upload
                                              documents, and track admission
                                              status for your preferred colleges
                                              across AP.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="item col-12 col-sm-12">
                                        <div className="item-box style2">
                                          <div className="top-inner">
                                            <div className="features-box-image number">
                                              3
                                            </div>
                                          </div>
                                          <div className="features-box-content">
                                            <h3 className="title">
                                              Migration & Accommodation
                                            </h3>
                                            <div className="description">
                                              Get assistance with hostel
                                              facilities, PG accommodations, and
                                              relocation support in your chosen
                                              city.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="item col-12 col-sm-12">
                                        <div className="item-box style2">
                                          <div className="top-inner">
                                            <div className="features-box-image number">
                                              4
                                            </div>
                                          </div>
                                          <div className="features-box-content">
                                            <h3 className="title">
                                              Enroll & Start Journey
                                            </h3>
                                            <div className="description">
                                              Complete enrollment, attend
                                              orientation, and begin your
                                              educational journey at your dream
                                              college in Andhra Pradesh.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-d3adec1 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="d3adec1"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4351629"
                            data-id={4351629}
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-604ce96 elementor-widget elementor-widget-heading"
                                data-id="604ce96"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    Our Students{" "}
                                    <span className="text-theme">Reviews</span>
                                  </h2>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-5227415 elementor-widget__width-initial elementor-widget elementor-widget-text-editor"
                                data-id={5227415}
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  Lorem ipsum dolor sit amet, consectetur
                                  adipiscing elit, sed do eiusmod tempor
                                  incididunt ut labore et dolore magna aliqua.
                                  Ut enim ad minim veniam.{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-a03b41a elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="a03b41a"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b872564"
                            data-id="b872564"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-e580d87 elementor-widget elementor-widget-apus_element_testimonials"
                                data-id="e580d87"
                                data-element_type="widget"
                                data-widget_type="apus_element_testimonials.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="widget-testimonials  style1">
                                    <div
                                      className="slick-carousel testimonial-main slick-initialized slick-slider"
                                      data-items={3}
                                      data-large={2}
                                      data-medium={2}
                                      data-small={1}
                                      data-smallest={1}
                                      data-pagination="false"
                                      data-nav="true"
                                      data-infinite="true"
                                    >
                                      <button
                                        type="button"
                                        className="slick-arrow slick-prev"
                                        style={{}}
                                      >
                                        <i className="fa fa-angle-left" />
                                        <span className="textnav">
                                          Previous
                                        </span>
                                      </button>
                                      <div className="slick-list draggable">
                                        <div
                                          className="slick-track"
                                          style={{
                                            opacity: 1,
                                            width: 5200,
                                            transform:
                                              "translate3d(-1200px, 0px, 0px)",
                                          }}
                                        >
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={-3}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Adam Riky
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={-2}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={301}
                                                          height={303}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png 301w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-298x300.png 298w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-150x150.png 150w"
                                                          sizes="(max-width: 301px) 100vw, 301px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      John Doe
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={-1}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      David Garza
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-current slick-active"
                                            data-slick-index={0}
                                            aria-hidden="false"
                                            style={{ width: 400 }}
                                            tabIndex={0}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={301}
                                                          height={303}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png 301w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-298x300.png 298w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-150x150.png 150w"
                                                          sizes="(max-width: 301px) 100vw, 301px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Robert Fox
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      4.5
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-active"
                                            data-slick-index={1}
                                            aria-hidden="false"
                                            style={{ width: 400 }}
                                            tabIndex={0}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={1000}
                                                          height={1000}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3.jpg 1000w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-410x410.jpg 410w"
                                                          sizes="(max-width: 1000px) 100vw, 1000px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Roy Cardona
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      4.5
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-active"
                                            data-slick-index={2}
                                            aria-hidden="false"
                                            style={{ width: 400 }}
                                            tabIndex={0}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Adam Riky
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide"
                                            data-slick-index={3}
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={301}
                                                          height={303}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png 301w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-298x300.png 298w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-150x150.png 150w"
                                                          sizes="(max-width: 301px) 100vw, 301px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      John Doe
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide"
                                            data-slick-index={4}
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      David Garza
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={5}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={301}
                                                          height={303}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png 301w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-298x300.png 298w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-150x150.png 150w"
                                                          sizes="(max-width: 301px) 100vw, 301px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Robert Fox
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      4.5
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={6}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={1000}
                                                          height={1000}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3.jpg 1000w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-3-410x410.jpg 410w"
                                                          sizes="(max-width: 1000px) 100vw, 1000px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Roy Cardona
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      4.5
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={7}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      Adam Riky
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={8}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={301}
                                                          height={303}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1.png 301w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-298x300.png 298w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-1-150x150.png 150w"
                                                          sizes="(max-width: 301px) 100vw, 301px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      John Doe
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="item slick-slide slick-cloned"
                                            data-slick-index={9}
                                            id=""
                                            aria-hidden="true"
                                            style={{ width: 400 }}
                                            tabIndex={-1}
                                          >
                                            <div className="testimonials-item style1">
                                              <div className="inner-top">
                                                <div className="d-flex align-items-center">
                                                  <div className="wrapper-avarta">
                                                    <div className="avarta d-flex justify-content-center align-items-center">
                                                      <div className="image-wrapper">
                                                        <img
                                                          loading="lazy"
                                                          decoding="async"
                                                          width={770}
                                                          height={770}
                                                          src="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg"
                                                          className="attachment-full size-full"
                                                          alt=""
                                                          srcSet="https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2.jpg 770w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-300x300.jpg 300w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-150x150.jpg 150w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-768x768.jpg 768w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-500x500.jpg 500w, https://demoapus1.com/skillup/wp-content/uploads/2022/05/user-2-410x410.jpg 410w"
                                                          sizes="(max-width: 770px) 100vw, 770px"
                                                        />
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                  <div className="info-testimonials">
                                                    <h3 className="name-client">
                                                      David Garza
                                                    </h3>{" "}
                                                    <div className="job">
                                                      Linkedin Leader
                                                    </div>
                                                    <div className="star">
                                                      <i className="fa fa-star" />
                                                      5.0
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="description">
                                                Faucibus tristique felis potenti
                                                ultrices ornare rhoncus semper
                                                hac facilisi Rutrum tellus lorem
                                                sem velit nisi non pharetra in
                                                dui.
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        className="slick-arrow slick-next"
                                        style={{}}
                                      >
                                        <span className="textnav">Next</span>
                                        <i className="fa fa-angle-right" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-fbaca93 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="fbaca93"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4cd4a2a"
                            data-id="4cd4a2a"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-bcc542c elementor-widget elementor-widget-heading"
                                data-id="bcc542c"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    Latest News &amp;{" "}
                                    <span className="text-theme">Articles</span>
                                  </h2>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-4cdfbe0 elementor-widget__width-initial elementor-widget elementor-widget-text-editor"
                                data-id="4cdfbe0"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  Lorem ipsum dolor sit amet, consectetur
                                  adipiscing elit, sed do eiusmod tempor
                                  incididunt ut labore et dolore magna aliqua.
                                  Ut enim ad minim veniam.{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-701f087 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="701f087"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                        style={{ width: 1425, left: "-127.4px" }}
                      >
                        <div className="elementor-container elementor-column-gap-extended">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-75cb95b"
                            data-id="75cb95b"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-bd0d84c elementor-widget elementor-widget-apus_element_posts"
                                data-id="bd0d84c"
                                data-element_type="widget"
                                data-settings='{"columns":3,"slides_to_scroll":3}'
                                data-widget_type="apus_element_posts.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="widget-blogs widget m-0  carousel">
                                    <div className="widget-content">
                                      <div className="inner-carousel">
                                        <div
                                          className="slick-carousel hidden-dots slick-initialized slick-slider"
                                          data-items={3}
                                          data-large={2}
                                          data-small={1}
                                          data-slidestoscroll={3}
                                          data-slidestoscroll_smallmedium={3}
                                          data-slidestoscroll_extrasmall={1}
                                          data-pagination="false"
                                          data-nav="true"
                                        >
                                          <div className="slick-list draggable">
                                            <div
                                              className="slick-track"
                                              style={{
                                                opacity: 1,
                                                width: 1200,
                                                transform:
                                                  "translate3d(0px, 0px, 0px)",
                                              }}
                                            >
                                              <div
                                                className="item slick-slide slick-current slick-active"
                                                data-slick-index={0}
                                                aria-hidden="false"
                                                style={{ width: 400 }}
                                                tabIndex={0}
                                              >
                                                <article className="post post-layout post-grid post-40 type-post status-publish format-standard has-post-thumbnail hentry category-accounting tag-lifestyle tag-music tag-travel">
                                                  <div className="top-image">
                                                    <figure className="entry-thumb">
                                                      <a
                                                        className="post-thumbnail"
                                                        aria-hidden="true"
                                                        tabIndex={0}
                                                      >
                                                        <div className="image-wrapper">
                                                          <img
                                                            decoding="async"
                                                            src="https://demoapus1.com/skillup/wp-content/uploads/elementor/thumbs/b-1-ppd9thaksf8fnyikd8s83il6f1v86oidmxbczpmz28.png"
                                                            className="attachment-xx1x1 size-xx1x1"
                                                            alt=""
                                                          />
                                                        </div>
                                                      </a>
                                                    </figure>{" "}
                                                  </div>
                                                  <div className="col-content">
                                                    <div className="list-categories">
                                                      <a
                                                        className="categories-name"
                                                        tabIndex={0}
                                                      >
                                                        Accounting
                                                      </a>
                                                    </div>{" "}
                                                    <h4 className="entry-title">
                                                      <a tabIndex={0}>
                                                        Let’s Know How Skillup
                                                        Work Fast and Secure?
                                                      </a>
                                                    </h4>
                                                    <div className="description">
                                                      Lorem ipsum dolor sit
                                                      amet, consectetur
                                                      adipisicing elit, sed do
                                                      eiusmod ...
                                                    </div>
                                                  </div>
                                                  <div className="bottom-layout-info d-flex align-items-center">
                                                    <a
                                                      className="avatar-author d-flex align-items-center justify-content-center"
                                                      tabIndex={0}
                                                    >
                                                      <img
                                                        src="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg"
                                                        srcSet="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg 2x"
                                                        className="avatar avatar-32 photo"
                                                        height={32}
                                                        width={32}
                                                        decoding="async"
                                                      />{" "}
                                                    </a>
                                                    <span className="date ms-auto d-flex align-items-center">
                                                      <i className="fa fa-clock text-warning" />
                                                      April 9, 2022{" "}
                                                    </span>
                                                  </div>
                                                </article>{" "}
                                              </div>
                                              <div
                                                className="item slick-slide slick-active"
                                                data-slick-index={1}
                                                aria-hidden="false"
                                                style={{ width: 400 }}
                                                tabIndex={0}
                                              >
                                                <article className="post post-layout post-grid post-38 type-post status-publish format-standard has-post-thumbnail hentry category-business tag-branding tag-fashion tag-lifestyle">
                                                  <div className="top-image">
                                                    <figure className="entry-thumb">
                                                      <a
                                                        className="post-thumbnail"
                                                        aria-hidden="true"
                                                        tabIndex={0}
                                                      >
                                                        <div className="image-wrapper">
                                                          <img
                                                            decoding="async"
                                                            src="https://demoapus1.com/skillup/wp-content/uploads/elementor/thumbs/b-2-ppd9thaksf8fnyikd8s83il6f1v86oidmxbczpmz28.png"
                                                            className="attachment-xx1x1 size-xx1x1"
                                                            alt=""
                                                          />
                                                        </div>
                                                      </a>
                                                    </figure>{" "}
                                                  </div>
                                                  <div className="col-content">
                                                    <div className="list-categories">
                                                      <a
                                                        className="categories-name"
                                                        tabIndex={0}
                                                      >
                                                        Business
                                                      </a>
                                                    </div>{" "}
                                                    <h4 className="entry-title">
                                                      <a tabIndex={0}>
                                                        How To Improove Digital
                                                        Marketing for Fast SEO
                                                      </a>
                                                    </h4>
                                                    <div className="description">
                                                      At vero eos et accusamus
                                                      et iusto odio dignissimos
                                                      ducimus qui ...
                                                    </div>
                                                  </div>
                                                  <div className="bottom-layout-info d-flex align-items-center">
                                                    <a
                                                      className="avatar-author d-flex align-items-center justify-content-center"
                                                      tabIndex={0}
                                                    >
                                                      <img
                                                        src="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg"
                                                        srcSet="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg 2x"
                                                        className="avatar avatar-32 photo"
                                                        height={32}
                                                        width={32}
                                                        decoding="async"
                                                      />{" "}
                                                    </a>
                                                    <span className="date ms-auto d-flex align-items-center">
                                                      <i className="fa fa-clock text-warning" />
                                                      April 9, 2022{" "}
                                                    </span>
                                                  </div>
                                                </article>{" "}
                                              </div>
                                              <div
                                                className="item slick-slide slick-active"
                                                data-slick-index={2}
                                                aria-hidden="false"
                                                style={{ width: 400 }}
                                                tabIndex={0}
                                              >
                                                <article className="post post-layout post-grid post-36 type-post status-publish format-standard has-post-thumbnail hentry category-marketing tag-branding tag-music tag-travel">
                                                  <div className="top-image">
                                                    <figure className="entry-thumb">
                                                      <a
                                                        className="post-thumbnail"
                                                        aria-hidden="true"
                                                        tabIndex={0}
                                                      >
                                                        <div className="image-wrapper">
                                                          <img
                                                            decoding="async"
                                                            src="https://demoapus1.com/skillup/wp-content/uploads/elementor/thumbs/b-3-ppd9thaksf8fnyikd8s83il6f1v86oidmxbczpmz28.png"
                                                            className="attachment-xx1x1 size-xx1x1"
                                                            alt=""
                                                          />
                                                        </div>
                                                      </a>
                                                    </figure>{" "}
                                                  </div>
                                                  <div className="col-content">
                                                    <div className="list-categories">
                                                      <a
                                                        className="categories-name"
                                                        tabIndex={0}
                                                      >
                                                        Marketing
                                                      </a>
                                                    </div>{" "}
                                                    <h4 className="entry-title">
                                                      <a tabIndex={0}>
                                                        How To Register &amp;
                                                        Enrolled on SkillUp Step
                                                        by Step?
                                                      </a>
                                                    </h4>
                                                    <div className="description">
                                                      Nemo enim ipsam voluptatem
                                                      quia voluptas sit
                                                      aspernatur aut odit aut
                                                      ...
                                                    </div>
                                                  </div>
                                                  <div className="bottom-layout-info d-flex align-items-center">
                                                    <a
                                                      className="avatar-author d-flex align-items-center justify-content-center"
                                                      href=""
                                                      tabIndex={0}
                                                    >
                                                      <img
                                                        src="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg"
                                                        srcSet="https://demoapus1.com/skillup/wp-content/uploads/learn-press-profile/1/491704192b1408ade8559e83e6de80bb.jpeg 2x"
                                                        className="avatar avatar-32 photo"
                                                        height={32}
                                                        width={32}
                                                        decoding="async"
                                                      />{" "}
                                                    </a>
                                                    <span className="date ms-auto d-flex align-items-center">
                                                      <i className="fa fa-clock text-warning" />
                                                      April 9, 2022{" "}
                                                    </span>
                                                  </div>
                                                </article>{" "}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  {/* .site-main */}
                </div>
                {/* .content-area */}
              </div>
            </section>
          </div>
          {/* .site-content */}
          <div
            id="apus-footer"
            className="apus-footer footer-builder-wrapper  footer-1"
          >
            <div className="apus-footer-inner">
              {" "}
              <div
                data-elementor-type="wp-post"
                data-elementor-id={120}
                className="elementor elementor-120"
              >
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-36ab62b elementor-section-stretched elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="36ab62b"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                  style={{ width: 1425, left: 0 }}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-65fee3d"
                      data-id="65fee3d"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-4d44e40 elementor-widget elementor-widget-heading"
                          data-id="4d44e40"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Do You Have Questions ?
                            </h2>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-93172c1 elementor-widget elementor-widget-text-editor"
                          data-id="93172c1"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            We’ll help you to grow your career and growth.{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7596314"
                      data-id={7596314}
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-989627c elementor-widget__width-auto elementor-widget elementor-widget-button"
                          data-id="989627c"
                          data-element_type="widget"
                          data-widget_type="button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                              <a
                                className="elementor-button elementor-button-link elementor-size-md"
                                href="#"
                              >
                                <span className="elementor-button-content-wrapper">
                                  <span className="elementor-button-text">
                                    Contact Us Today
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-5340d92 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="5340d92"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                  style={{ width: 1425, left: 0 }}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    {/* Column 1 - Office Info */}
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-5932597"
                      data-id={5932597}
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-781650f elementor-widget__width-initial elementor-widget elementor-widget-apus_element_logo"
                          data-id="781650f"
                          data-element_type="widget"
                          data-widget_type="apus_element_logo.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="logo ">
                              {/* Logo area - kept same as original */}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "14px",
                              lineHeight: "1.5",
                              color: "white",
                            }}
                          >
                            O/o COMMISSIONER OF HIGHER EDUCATION, A.P
                            <br />
                            D.NO. 11-307, GARUDADRI K.K TOWERS
                            <br />
                            LAKSHMI NARASIMHA COLONY, NH-5 SERVICE ROAD
                            <br />
                            NEAR Dr. NTR VAIDYA SEVA TRUST
                            <br />
                            MANGALAGIRI, GUNTUR DISTRICT – 522503
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Column 2 - For Students */}
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-aee24e0"
                      data-id="aee24e0"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-83aa072 elementor-widget elementor-widget-apus_element_nav_menu"
                          data-id="83aa072"
                          data-element_type="widget"
                          data-widget_type="apus_element_nav_menu.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="widget-nav-menu m-0 widget">
                              <h2 className="widget-title">For Students</h2>
                              <div className="widget-content">
                                <div className="menu-course-categories-container">
                                  <ul
                                    id="menu-course-categories"
                                    className="menu"
                                  >
                                    <li>
                                      <a href="#">Scholarship Programs</a>
                                    </li>
                                    <li>
                                      <a href="#">College Directory</a>
                                    </li>
                                    <li>
                                      <a href="#">Course Options</a>
                                    </li>
                                    <li>
                                      <a href="#">Admission Process</a>
                                    </li>
                                    <li>
                                      <a href="#">Career Counseling</a>
                                    </li>
                                    <li>
                                      <a href="#">Student Services</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Column 3 - Information Hub */}
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-3cb1c99"
                      data-id="3cb1c99"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-040c688 elementor-widget elementor-widget-apus_element_nav_menu"
                          data-id="040c688"
                          data-element_type="widget"
                          data-widget_type="apus_element_nav_menu.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="widget-nav-menu m-0 widget">
                              <h2 className="widget-title">Information Hub</h2>
                              <div className="widget-content">
                                <div className="menu-helpful-articles-container">
                                  <ul
                                    id="menu-helpful-articles"
                                    className="menu"
                                  >
                                    <li>
                                      <a href="#">Student Migration Guide</a>
                                    </li>
                                    <li>
                                      <a href="#">College Rankings</a>
                                    </li>
                                    <li>
                                      <a href="#">Exam Notifications</a>
                                    </li>
                                    <li>
                                      <a href="#">Fee Structure</a>
                                    </li>
                                    <li>
                                      <a href="#">Student Helpline</a>
                                    </li>
                                    <li>
                                      <a href="#">About CHE</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Column 4 - Quick Links */}
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-afe2527"
                      data-id="afe2527"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7b2a602 elementor-widget elementor-widget-apus_element_nav_menu"
                          data-id="7b2a602"
                          data-element_type="widget"
                          data-widget_type="apus_element_nav_menu.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="widget-nav-menu m-0 widget">
                              <h2 className="widget-title">Quick Links</h2>
                              <div className="widget-content">
                                <div className="menu-quick-links-container">
                                  <ul id="menu-quick-links" className="menu">
                                    <li>
                                      <a href="#">RTI</a>
                                    </li>
                                    <li>
                                      <a href="#">Tenders</a>
                                    </li>
                                    <li>
                                      <a href="#">Downloads</a>
                                    </li>
                                    <li>
                                      <a href="#">Notifications</a>
                                    </li>
                                    <li>
                                      <a href="#">Contact Us</a>
                                    </li>
                                    <li>
                                      <a href="#">Student Feedback</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>{" "}
          <a href="#" id="back-to-top" className="add-fix-top">
            <i className="ti-arrow-up" />
          </a>
        </div>
        {/* .site */}
        <span id="elementor-device-mode" className="elementor-screen-only" />
        <div
          className="widget_shopping_cart_live_region screen-reader-text"
          role="status"
        />
      </>
    </div>
  );
};

export default Test;
